import {ImportingDataTypes} from "../../types";
import {createInvalidPartSection, PreventionInvalidityCode} from "./shared";

export const preventativeInteraction = {
    datasourceId: ImportingDataTypes.productFlatShippingRates,
    sections: [
        createInvalidPartSection('partNo'),
        {
            sectionKey: 'invalidAmount',
            sectionTitle: 'Invalid Amount',
            invalidityCode: PreventionInvalidityCode.INVALID_AMOUNT,
            fields: [
                {
                    key: 'partNo',
                    label: 'Part Number',
                    type: 'text',
                    extractValue: (o) => typeof o === 'string' ? o : o?.partNo ?? null,
                    modifyRow: (row, val) => ({...row, partNo: val}),
                },
                {
                    key: 'amount',
                    label: 'Amount',
                    type: 'input',
                    textFieldProps: {inputProps: {type: 'number', min: 0, step: 'any'}},
                    modifyRow: (row, val) => ({...row, amount: val}),
                },
            ],
        },
    ],
};
